import { createColumn, defaultColumns, inputTextField, relationField } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'Name',
    isTitle: true,
    field: 'teamName',
    component: inputTextField({ req: true })
  }),
  createColumn({
    label: 'Event',
    field: 'event',
    ...relationField({
      type: 'one',
      namespace: 'event',
      filterIs: 'text-filter'
    })
  }),
  createColumn({
    label: 'Description',
    isTitle: true,
    field: 'description',
    component: inputTextField({ type: 'textarea', req: true })
  })
].concat(defaultColumns)
